import React from 'react';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Security, ImplicitCallback } from '@okta/okta-react';
import store from './store';
import Login from './views/Login';
import * as serviceWorker from './serviceWorker';
import history from './history';
import "bootstrap/dist/css/bootstrap.min.css";
import './styles.css';

const config = {
  issuer: process.env.REACT_APP_OKTA_URL,
  redirect_uri: window.location.origin + '/implicit/callback',
  client_id: process.env.REACT_APP_OKTA_CLIENT_ID,
  pkce: true
};

var ReactDOM = require('react-dom');

const renderApp = () =>
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Security {...config} className="okta">
          <Route
            path="/"
            component={Login}
            baseUrl="https://adamsstreetpartnersext.okta.com"
          />
          <Route path="/implicit/callback" component={ImplicitCallback} />
        </Security>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./views/App', renderApp);
}

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
